module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.flag) ? _c('div', {
    staticClass: "bigDiv"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOL === '1'),
      expression: "showOL === '1'"
    }],
    staticClass: "goToOrderListDiv",
    on: {
      "click": _vm.goToOrderList
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/iconikt@2x.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("前往订单列表")])]), _vm._v(" "), _c('div', {
    staticClass: "statusDiv"
  }, [_c('div', {
    staticClass: "statusDescDiv"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.order.statusDesc))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/icon70o@2x.png")
    }
  })]), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order.status === 0),
      expression: "order.status === 0"
    }],
    staticClass: "span1",
    on: {
      "click": _vm.goTo
    }
  }, [_vm._v("去支付")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order.status === 1),
      expression: "order.status === 1"
    }],
    staticClass: "span1",
    on: {
      "click": _vm.goTo
    }
  }, [_vm._v(_vm._s(_vm.isUploading === undefined ? '去上传' : '上传中'))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order.status >= 2),
      expression: "order.status >= 2"
    }],
    staticClass: "span2",
    on: {
      "click": _vm.goTo
    }
  }, [_vm._v("预览电子档")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order.status >= 2 && _vm.order.sku.categoryId === '1'),
      expression: "order.status >= 2 && order.sku.categoryId === '1'"
    }],
    staticClass: "editDiv"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon7040@2x.png")
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (!_vm.countdownStatus && _vm.order.status >= 2 && (_vm.order.sku.categoryId === '1' || _vm.order.sku.categoryId === '5')) ? _c('div', {
    staticClass: "countdownDiv"
  }, [_c('span', [_vm._v("\n                自助编辑倒计时："), _c('span', [_vm._v(_vm._s(_vm.countdownTime))])])]) : _vm._e()]), _vm._v(" "), (_vm.order.address) ? _c('div', {
    staticClass: "addressDiv"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tipDiv"
  }, [_c('div', {
    staticClass: "userTip"
  }, [_c('span', [_vm._v(_vm._s(_vm.order.address.receiverName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.address.receiverPhone))])]), _vm._v(" "), _c('div', {
    staticClass: "addressTip"
  }, [(_vm.order.address.province !== _vm.order.address.city) ? _c('span', [_vm._v(_vm._s(_vm.order.address.province))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.address.city))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.address.country))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.address.town))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.address.details))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detailDiv"
  }, [_c('div', {
    staticClass: "topDiv"
  }, [_c('div', {
    staticClass: "coverDiv"
  }, [_c('img', {
    attrs: {
      "src": _vm.order.cover,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "topOrderDiv"
  }, [_c('div', {
    staticClass: "titleDiv"
  }, [_c('span', [_vm._v(_vm._s(_vm.order.name))]), _vm._v(" "), _c('span', [_vm._v("¥" + _vm._s(_vm.order.dealTotalPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "descOrderDiv"
  }, _vm._l((_vm.descriptions), function(item, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "descDiv"
  }, [_c('div', [_c('span', [_vm._v("购买数量")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.dealQuantity))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rollFlag),
      expression: "rollFlag"
    }]
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("-¥100.00")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("运费")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.sku.isFreeShipping ? '免运费' : '+¥' + _vm.order.shipping))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("产品实付")]), _vm._v(" "), _c('span', [_vm._v("¥" + _vm._s(_vm.order.dealTotalPrice))])])])]), _vm._v(" "), _c('div', {
    staticClass: "infoDiv"
  }, [_c('div', [_c('span', [_vm._v("订单编号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.orderId))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("创建时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.createTime))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("快递单号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.expressId === undefined ? '暂无' : _vm.order.expressId))])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOL !== undefined && _vm.showOL !== null && _vm.showOL !== ''),
      expression: "showOL !== undefined && showOL !== null && showOL !== ''"
    }],
    staticClass: "moreDiv"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/iconi89@2x.png")
    },
    on: {
      "click": _vm.shouye
    }
  })]), _vm._v(" "), _c('nut-dialog', {
    attrs: {
      "title": "升级提示",
      "visible": _vm.dialogUpgrade,
      "okBtnTxt": "立刻升级",
      "noOkBtn": true,
      "cancelBtnTxt": "知道了"
    },
    on: {
      "cancel-btn-click": function($event) {
        _vm.dialogUpgrade = false
      },
      "close": function($event) {
        _vm.dialogUpgrade = false
      }
    }
  }, [_c('span', {
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.upgradeTips || '当前APP版本过低，请升级至8.0.0及以上版本后再进行支付。'))])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n                可点击"), _c('span', [_vm._v("「预览电子档」")]), _vm._v("查看Amiao为您设计的相册\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imgDiv"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon061@2x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("印刷方式")]), _vm._v(" "), _c('span', [_vm._v("激光冲印")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("棉花券"), _c('img', {
    attrs: {
      "src": require("../../assets/images/icon065@2x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footDiv"
  }, [_c('span', [_vm._v("订单如有问题请与微信客服联系：")]), _vm._v(" "), _c('span', [_vm._v("xiaomianhua012")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54f8a38f"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/orderDetail.vue
// module id = 454
// module chunks = 1